<template>
  <div>
    <a-modal
      v-model="showModal"
      class="mobile-modal-fullscreen-msg-modal"
      :centered="true"
      :footer="null"
      :closable="false"
      :dialog-style="{
        'margin-top': '0px',
        width: '100px !important',
        'min-height': '500px'
      }"
      @ok="() => (showModal = false)"
    >
    <div class="header">
          <font-awesome-icon
            @click="() => (showModal = false)"
            class="open-mob font-black mr-3 font20"
            size="2x"
            :icon="['fal', 'times']"
          />
          <span class="title">About</span>
          <font-awesome-icon
            @click="() => (showModal = false)"
            class="close-mob font-black mr-3 font20"
            size="2x"
            :icon="['fal', 'times']"
          />
          <button @click="save()" class="apply-filter-btn-mob" :style="{ background:getPrimaryColor() }">Add</button>
      </div>
      <div class="row">
        <quillEditor
          class="quill-edit"
          v-model="about"
          ref="quillEditor"
          :options="editorOption"
        ></quillEditor>

        <div class="w-100 d-flex justify-content-end align-items-end">
          <a-button
            key="submit"
            type="primary"
            @click="save()"
            class="primary-button dovemed-button web"
            :style="{
              background: getPrimaryColor(),
              border: getPrimaryColor()
            }"
            >Add</a-button
          >
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

import { quillEditor } from "vue-quill-editor";
import { RepositoryFactory } from "../../../repositories/RepositoryFactory";

const UserRepository = RepositoryFactory.get("user");

export default {
  name: "EditAdvocateAbout",
  components: {
    quillEditor
  },
  data() {
    return {
      showModal: false,
      data: null,
      about: null,
      editorOption: {
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],

            [{ list: "ordered" }, { list: "bullet" }],

            ["clean"]
          ]
        }
      }
    };
  },

  methods: {
    show(data) {
      this.showModal = true;
      this.data = data;
      this.about = data.about;
    },
    hide() {
      this.showModal = false;
    },
    save() {
      const payload = {
        about: this.about
      };
      UserRepository.updateAdvocateDetails(this.authUser.user, payload)
        .then(res => {
          this.$emit("refresh");
          this.hide();
        })
        .catch(err => {});
    }
  }
};
</script>

<style lang="scss" scoped>

.web{
  display:flex;
  @media screen and (max-width:700px) {
    display: none;
  }
}
.open-mob{
  display: none;
  @media screen and (max-width:700px) {
    display: flex;
  }
}
.close-mob{
  display: flex;
  @media screen and (max-width:700px) {
    display: none;
  }
}

.apply-filter-btn-mob{
  display: none;
  @media screen and (max-width:700px) {
    display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  width: 82px;
  height: 48px;
  border-radius: 6px;
  text-transform: capitalize;
  color: #FFFFFF;
  border: none;
  cursor: pointer;
  }
}

.title{
    width: 100%;
font-weight: 700;
font-size: 24px;
line-height: 32px;
color: #33415F;
@media screen and (max-width:700px) {
    font-size: 20px !important;
  }
}
.header{
display: flex;
flex-direction: row;
align-items: center;
padding: 0px;
width: 100%;
margin-bottom: 24px;
}
.row {
  min-height: 320px;
}
.quill-editor {
  width: 100%;
  height: 200px;
}
.dovemed-button {
  padding: 12px 45px;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/profile/AdvocateAbout.vue